const LOAD_ERROR = 'redux-example/errors/LOAD_ERROR';

const initialState = {
  loadError: false
};

export default function errors(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_ERROR:
      return {
        ...state,
        loadError: true
      };
    default:
      return state;
  }
}


export function loadError() {
  return {
    types: [LOAD_ERROR]
  };
}
